
import React from 'react';
import { Plus, ChevronsLeft } from 'lucide-react';
import { SocialProfile } from './types';
import ProfilesList from './ProfilesList';
import { Button } from '@/components/ui/button';
import { SubscriptionGuard } from '@/components/subscription/SubscriptionGuard';

interface ExpandedSidebarProps {
  handlePageChange: (page: string) => void;
  setIsCollapsed: (value: boolean) => void;
  profiles: SocialProfile[];
  isSingleSelectionMode: boolean;
  selectedProfiles: string[];
  singleSelectedProfile: string;
  toggleProfileSelection: (id: string) => void;
  setSingleSelectedProfile: (id: string) => void;
  isLoading: boolean;
  requireSubscription?: boolean;
  isSubscriptionActive?: boolean;
}

const ExpandedSidebar = ({
  handlePageChange,
  setIsCollapsed,
  profiles,
  isSingleSelectionMode,
  selectedProfiles,
  singleSelectedProfile,
  toggleProfileSelection,
  setSingleSelectedProfile,
  isLoading,
  requireSubscription = false,
  isSubscriptionActive = true
}: ExpandedSidebarProps) => {
  
  const AddProfileButton = () => (
    <Button
      onClick={() => handlePageChange('add-profile')}
      className="w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
      variant="outline"
    >
      <Plus className="h-4 w-4 mr-2" />
      Ajouter un profil
    </Button>
  );
  
  return (
    <div className="w-64 flex-shrink-0 h-full border-r border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 flex flex-col">
      <div className="p-4 flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <h2 className="font-semibold text-lg">Profils sociaux</h2>
        <button
          onClick={() => setIsCollapsed(true)}
          className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400"
          aria-label="Réduire le panneau"
        >
          <ChevronsLeft className="h-5 w-5" />
        </button>
      </div>
      
      <div className="flex-1 overflow-y-auto p-3">
        <ProfilesList
          profiles={profiles}
          isSingleSelectionMode={isSingleSelectionMode}
          selectedProfiles={selectedProfiles}
          singleSelectedProfile={singleSelectedProfile}
          toggleProfileSelection={toggleProfileSelection}
          setSingleSelectedProfile={setSingleSelectedProfile}
          isLoading={isLoading}
        />
      </div>
      
      <div className="p-3 border-t border-gray-100 dark:border-gray-700">
        {requireSubscription ? (
          <SubscriptionGuard>
            <AddProfileButton />
          </SubscriptionGuard>
        ) : (
          <AddProfileButton />
        )}
      </div>
    </div>
  );
};

export default ExpandedSidebar;
